export type TBorderSide = 'Bottom' | 'Left' | 'Right' | 'Top' | 'All';

type TPrefixedBorderSide<T extends string> = `${T}${TBorderSide}`;

export const getBorderClassName = <T extends string>(
  prefix: T,
  withBorder: TBorderSide
): TPrefixedBorderSide<T> => `${prefix}${withBorder}`;

export function getBorderClassNames<T extends string>(
  prefix: T,
  withBorder: TBorderSide
): TPrefixedBorderSide<T>;
export function getBorderClassNames<T extends string>(
  prefix: T,
  withBorder: TBorderSide[]
): Array<TPrefixedBorderSide<T>>;
export function getBorderClassNames<T extends string>(
  prefix: T,
  withBorder: TBorderSide | TBorderSide[]
): TPrefixedBorderSide<T> | Array<TPrefixedBorderSide<T>>;
export function getBorderClassNames<T extends string>(
  prefix: T,
  withBorder: TBorderSide | TBorderSide[]
): TPrefixedBorderSide<T> | Array<TPrefixedBorderSide<T>> {
  if (typeof withBorder === 'string') {
    return getBorderClassName(prefix, withBorder);
  }
  return withBorder.map(v => getBorderClassName(prefix, v));
}

// TODO: potentially it may be used in UI for all union string props
export function getClassNamesFromMap<
  K extends string,
  T extends Record<K, unknown>,
>(map: T, classNames: K): T[K];
export function getClassNamesFromMap<
  K extends string,
  T extends Record<K, unknown>,
>(map: T, classNames: K[]): Array<T[K]>;
export function getClassNamesFromMap<
  K extends string,
  T extends Record<K, unknown>,
>(map: T, classNames: K | K[]): T[K] | Array<T[K]>;
export function getClassNamesFromMap<
  K extends string,
  T extends Record<K, unknown>,
>(map: T, classNames: K | K[]): T[K] | Array<T[K]> {
  if (typeof classNames === 'string') return map[classNames];
  return classNames.map(className => map[className]);
}
